// CUSTOMIZED: Product Burger Menu
(() => {
  const drawer = document.getElementById('edm-product-drawer');
  const overlay = document.querySelector('.edm-drawer__overlay');
  const triggers = document.querySelectorAll('[data-edm-burger-trigger]');
  if (!drawer || !overlay || !triggers.length) return;

  const main = document.getElementById('MainContent');
  let lastFocus = null;
  const focusablesSelector = 'a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function setExpanded(all, val) {
    all.forEach(t => t.setAttribute('aria-expanded', String(val)));
  }

  function openDrawer() {
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('edm-no-scroll');
    if (main) main.setAttribute('inert', '');
    requestAnimationFrame(() => {
      drawer.setAttribute('data-open', '');
      setExpanded(triggers, true);
      drawer.querySelector('.edm-drawer__close')?.focus();
    });
  }

  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.removeAttribute('data-open');
    setExpanded(triggers, false);
    const onEnd = (e) => {
      if (e.propertyName !== 'transform') return;
      drawer.removeEventListener('transitionend', onEnd);
      drawer.hidden = true;
      overlay.hidden = true;
      document.body.classList.remove('edm-no-scroll');
      if (main) main.removeAttribute('inert');
      lastFocus?.focus();
    };
    drawer.addEventListener('transitionend', onEnd, { once: true });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-edm-burger-trigger]')) {
      openDrawer();
      return;
    }
    if (e.target.closest('#edm-product-drawer .edm-drawer__close') || e.target === overlay) {
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !drawer.hidden) {
      e.preventDefault();
      closeDrawer();
    }
    if (e.key === 'Tab' && !drawer.hidden) {
      const nodes = drawer.querySelectorAll(focusablesSelector);
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();

